import React from 'react';
import { Loader2 } from 'lucide-react';

export const PageHeader: React.FC<{
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}> = ({ title, subtitle, actions }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
    <div>
      <h1 className="mx-page-title">{title}</h1>
      {subtitle && <p className="mx-page-sub">{subtitle}</p>}
    </div>
    {actions && <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>{actions}</div>}
  </div>
);

export const EmptyState: React.FC<{
  icon?: React.ReactNode;
  title: string;
  hint?: string;
  action?: React.ReactNode;
}> = ({ icon, title, hint, action }) => (
  <div className="mx-card mx-card-pad" style={{ textAlign: 'center', padding: '56px 24px' }}>
    {icon && <div style={{ color: 'var(--mx-text-subtle)', marginBottom: 12 }}>{icon}</div>}
    <div style={{ fontWeight: 600, marginBottom: 4 }}>{title}</div>
    {hint && <div className="mx-muted" style={{ fontSize: 13, marginBottom: 16 }}>{hint}</div>}
    {action}
  </div>
);

export const MetricChip: React.FC<{
  icon?: React.ReactNode;
  label: string;
  title?: string;
}> = ({ icon, label, title }) => (
  <span className="mx-chip" title={title}>
    {icon}{label}
  </span>
);

export const Spinner: React.FC<{ size?: number; label?: string }> = ({ size = 16, label }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: 'var(--mx-text-muted)' }}>
    <Loader2 size={size} className="mx-spin" />{label}
  </span>
);
